import { useEffect, useState, useRef } from "react";
import { CommunicationSideBar } from "../components/communicationSideBar";
import { CommunicationScreen } from "../components/communicationScreen";
import { HorizontalLayout, VerticalPageLayout } from "../components/layout";
import { getAPI, postAPI } from "../api/api";

export function Communication({goToScreen, pageSwap}){
  const [searchQuery, setSearchQuery] = useState("");
  const [settingId, setSettingId] = useState(1);
  const [userChats, setUserChats] = useState([])
  const [currentChatUser, setCurrentChatUser] = useState({"chat_id": 0, "first_name": "", "last_name": "", "user_id": -1});
  const [currentChatMessages, setCurrentChatMessages] = useState([])
  const chatBottomRef = useRef(null);
  const [activeChat, setActiveChat]  = useState(-1)
  const [currentFiles, setCurrentFiles] = useState([])
  const [currentMessage, setCurrentMessage] = useState("")
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getUserChats = async () =>{
    const url = "api/communications/chats"
    const response = await getAPI(url)

    setUserChats(response.data);
  }

  async function openChat(index,idCourse) {
    setActiveChat(index)
    var userChats_copy = [...userChats]
    var chat = userChats_copy[index]
    setCurrentChatUser({"id_course": userChats_copy[index].id_course, "first_name": chat.responder_first_name, "last_name": chat.responder_last_name})
    const url = `api/communications/chats/${idCourse}/messages`
    const messages = await getAPI(url)
    setCurrentChatMessages(messages.data)
    setTimeout(function () {
      chatBottomRef.current.scrollIntoView();
    }, 1)
    read(idCourse)

  }
  const filteredChats = userChats.filter(chat => {
      const matchSetting = settingId === 2 ? chat.newMessage === 1 : settingId === 3 ? chat.archived === 1 : true;
      const courseTitle = (chat.title || "").toLowerCase();
      const responderName = `${chat.responder_first_name || ""} ${chat.responder_last_name || ""}`.toLowerCase();
      const query = searchQuery.toLowerCase();
      const lastMessage = (chat.last_message || "").toLowerCase();
      const matchSearch = courseTitle.includes(query) || responderName.includes(query) || lastMessage.includes(query);
      return matchSetting && matchSearch;
  });

  const read = async (idCourse) => {
      const query = `api/communications/chats/messages/open`
      const body = {"id_course": idCourse}
      await postAPI(query,body)
  }
  async function fetchChatMessages() {
    if (currentChatUser.chat_id == 0) {return}
    const id_course = filteredChats[activeChat].id_course
    const messages = await getAPI(`api/communications/chats/${id_course}/messages`)
    setCurrentChatMessages(messages.data)
    setTimeout(function () {
      chatBottomRef.current.scrollIntoView();
    }, 1)
  }
  const handleChatArchive = async (id_course, archive = true) => {
    await postAPI(`api/communications/chats/${id_course}/archive`, {
      archived: archive ? 1 : 0,
    });
    getUserChats();
  };
  async function sendChatMessage() {
    setTimeout(function () {
      chatBottomRef.current.scrollIntoView();
    }, 1)
    const id_course = filteredChats[activeChat].id_course
    await postAPI(`api/communications/chats/${id_course}/messages/create`, {"message_content": currentMessage})
    setCurrentMessage("")
    setCurrentFiles([])

    fetchChatMessages()
    getUserChats()
  }
  function goBackToChats() {
    setCurrentChatUser(null);
  }
  useEffect(function () {
    getUserChats()
  }, [])

  useEffect(function () {
    var message_updater = setInterval(async function () {
      fetchChatMessages()
    }, 3000)

    return () => {
      clearInterval(message_updater);
    }
  }, [])

  return (
    <VerticalPageLayout className={`page-in-animation phone-chat ${pageSwap && "page-out-animation"}`}>
      <HorizontalLayout className="horizontal standard-padding standard-rounded standard-margin complete-height card-background-color" style={{ width: "unset", height: "calc(100% - 72px)", borderStyle: "solid",borderWidth: "1px",borderColor: "var(--border-color)"}}>
        {isMobile ? (
          currentChatUser ? (
            <CommunicationScreen
              handleChatArchive={handleChatArchive}
              chatBottom={chatBottomRef}
              goBack={goBackToChats} 
              chattingUser={currentChatUser}
              chats={currentChatMessages}
              currentMessage={currentMessage}
              setCurrentMessage={setCurrentMessage}
              currentFiles={currentFiles}
              setCurrentFiles={setCurrentFiles}
              sendChatMessage={sendChatMessage}
              chatData={filteredChats[activeChat]}
            />
          ) : (
            <CommunicationSideBar
              openChat={(idx, course) => openChat(idx, course)}
              chats={filteredChats}
              activeChat={activeChat}
              settingId={settingId}
              setSettingId={setSettingId}
              searchValue={searchQuery}
              onSearchChange={setSearchQuery}
            />
          )
        ) : (
          <>
            <CommunicationSideBar searchValue={searchQuery} onSearchChange={setSearchQuery} settingId={settingId} setSettingId={setSettingId} activeChat={activeChat} openChat={(idx,course) => openChat(idx, course)} chats={filteredChats} />
            {currentChatUser && (
              <CommunicationScreen
                handleChatArchive={handleChatArchive}
                chatBottom={chatBottomRef}
                goToScreen={goToScreen}
                chattingUser={currentChatUser}
                chats={currentChatMessages}
                currentMessage={currentMessage}
                setCurrentMessage={setCurrentMessage}
                currentFiles={currentFiles}
                setCurrentFiles={setCurrentFiles}
                sendChatMessage={sendChatMessage}
                chatData={filteredChats[activeChat]}
              />
            )}
          </>
        )}
      </HorizontalLayout>
    </VerticalPageLayout>
  );
}